/* eslint-disable react/no-array-index-key */
/* eslint-disable eqeqeq */
import React, { PureComponent } from 'react';
import { useParams, Redirect } from 'react-router-dom';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import _isEqual from 'lodash/isEqual';
import ExamSections from '@components/Component/ExamSections';
import {
  useExamV2Access,
  useLearnosityExamAccess,
} from '@components/Component/LearnosityExams/ShowIfLearnosityExamFlagEnabled/ShowIfLearnosityExamFlagEnabled';
import LeftSideBarTest from '../../containers/LeftSideBar/LeftSideBarTest';
import TestDetailContent from '../../containers/TestDetailContent';
import TestDetailContentV2 from '../../containers/TestDetailContentV2';
import MainContent from '../../containers/MainContent';
import { PrimaryWrap } from '../Generals/stylesheets/General.style';
import { ROLE_TYPE } from '../../utils/enums';
import { selectors as CourseSelectors } from '../../reducers/courses';
import {
  LessonEmptyWrap,
  LessonEmptyIcon,
  LessonEmptyData,
  LessonEmptyAction,
} from '../LessonManagement/LessonManagement.style';
import * as SectionAPI from '../../apis/exam';

class TestManagement extends PureComponent {
  state = {
    exams: [],
  };

  componentDidMount() {
    document.title = 'Tests — ChalkTalk';
    const {
      sectionId,
      sectionsStudentGet,
      getCurriculumList,
      userRole,
      lastestExam,
      shouldRenderTestContent,
      courseId,
    } = this.props;
    if (sectionId !== null) {
      if (userRole !== ROLE_TYPE.STUDENT) {
        sectionsStudentGet(sectionId);
      }
      this.renderSessions();
    }

    getCurriculumList();
  }

  componentDidUpdate(prevProps) {
    const { sectionId: prevSectionId } = prevProps;
    const {
      sectionId,
      sectionsStudentGet,
      lastestExam,
      shouldRenderTestContent,
      courseId,
      userRole,
    } = this.props;

    if (sectionId !== null && !_isEqual(sectionId, prevSectionId)) {
      if (userRole !== ROLE_TYPE.STUDENT) {
        sectionsStudentGet(sectionId);
      }
      this.renderSessions();
    }
  }

  renderSessions = async () => {
    const { sectionDetail, history, courseId, match } = this.props;

    const { exams } = sectionDetail;
    if (exams) {
      const examPromises = [];
      for (let i = 0; i < exams.length; i++) {
        const response = SectionAPI.getExamDetail(exams[i]);
        examPromises.push(response);
      }
      const examsArray = (await Promise.all(examPromises).then((data) => data))
        .filter((item) => item.response?.data)
        .map((item) => item.response.data)
        .sort((a, b) => new Date(a.start_date) - new Date(b.start_date));

      this.setState({ exams: examsArray });
      let { id: examToRender } = examsArray[0];

      const unmarkedExams = examsArray.filter((exam) => exam.done !== true);

      examToRender = unmarkedExams.length
        ? unmarkedExams[0].id
        : examsArray[exams.length - 1].id;

      if (!match.params.examSessionId) {
        history.push(
          `/test/course/${courseId}/section/${sectionDetail.id}/exam/${examToRender}`,
        );
      }
    }
  };

  renderNoExam = () => {
    const pathNumber = Array.from(Array(23).keys());
    const { history, courseId, sectionId } = this.props;
    return (
      <MainContent>
        <LessonEmptyWrap>
          <LessonEmptyIcon className="chalktalk-schedule-calendar">
            {pathNumber.map((number, index) => (
              <i className={`path${number}`} key={index} />
            ))}
          </LessonEmptyIcon>
          <LessonEmptyData>
            <span>There are no exam created. </span>
            <span>Click </span>
            <LessonEmptyAction
              type="button"
              onClick={() =>
                history.push(
                  `/schedule/course/${courseId}/section/${sectionId}/create-exam-session`,
                )
              }
            >
              + Add new exam session
            </LessonEmptyAction>
          </LessonEmptyData>
        </LessonEmptyWrap>
      </MainContent>
    );
  };

  renderTestContent = () => {
    const { hasExamV2Access } = this.props;
    return hasExamV2Access ? <TestDetailContentV2 /> : <TestDetailContent />;
  };

  render() {
    const { shouldRenderTestContent, hasExamV2Access } = this.props;
    return (
      <PrimaryWrap>
        <ExamSections>
          <LeftSideBarTest
            exams={this.state.exams}
            pathName="/test/course"
            hasExamV2Access={hasExamV2Access}
          />
          {shouldRenderTestContent ? this.renderTestContent() : this.renderNoExam()}
        </ExamSections>
      </PrimaryWrap>
    );
  }
}

TestManagement.propTypes = {
  sectionId: PropTypes.any,
  sectionsStudentGet: PropTypes.func,
  getCurriculumList: PropTypes.func,
  shouldRenderTestContent: PropTypes.bool,
  lastestExam: PropTypes.any,
  history: PropTypes.any,
  courseId: PropTypes.any,
  userRole: PropTypes.string,
  sectionDetail: PropTypes.object,
};

const WrapperTestManagement = (props) => {
  const hasExamV2Access = useExamV2Access();
  const isLearnosityExam = useLearnosityExamAccess();
  const { courseId, sectionId } = useParams();
  const courseDetail = useSelector((state) =>
    CourseSelectors.getCourseDetailById(state, courseId),
  );

  if (isLearnosityExam) {
    let targetSectionId = sectionId;

    if (!targetSectionId && courseDetail?.sections?.length) {
      const activeSections = courseDetail.sections.filter(
        (item) => new Date(item.end_date).getTime() >= new Date().getTime(),
      );
      targetSectionId =
        activeSections.length > 0
          ? activeSections[0].id
          : courseDetail.sections[0].id;
    }

    if (targetSectionId) {
      return (
        <Redirect
          to={`/tests/course/${courseId}/section/${targetSectionId}`}
        />
      );
    }
    return <Redirect to={`/dashboard/course/${courseId}`} />;
  }

  return (
    <TestManagement
      {...props}
      hasExamV2Access={hasExamV2Access}
      isLearnosityExam={isLearnosityExam}
    />
  );
};
export default WrapperTestManagement;